import ClickOutside from '@/directives/click-outside';
import {i18n} from '@/i18n';
import {generateClasses} from '@formkit/themes';
import '@vuepic/vue-datepicker/dist/main.css';
import {VueQueryPlugin} from '@tanstack/vue-query';
import VueMagnifier from '@websitebeaver/vue-magnifier';
import {createApp} from 'vue';
import {VueRecaptchaPlugin} from 'vue-recaptcha/head';
import vSelect from 'vue-select';
import {createPinia} from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import CartItemImage from './components/cart-page/workshops/CartItemImage.vue';
import {initLinkWords} from '@academy/utils';

import App from './App.vue';
import {defaultConfig, plugin} from '@formkit/vue';

import 'sweetalert2/dist/sweetalert2.min.css';
import './assets/styles/main.scss';
import '@academy/components/index.css';
import '@/axios';
import "vue-select/dist/vue-select.css"
import formKitTheme from './formKitTheme';
import router from './router';
import {defaultOptionsQueryClient} from './services/query-client';

const app = createApp(App).use(
    plugin,
    defaultConfig({
        config: {
            classes: generateClasses(formKitTheme),
        },
    }),
);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

app.use(pinia);
app.use(router);
app.use(i18n);
app.use(VueQueryPlugin, {
    queryClientConfig: {
        defaultOptions: defaultOptionsQueryClient,
    },
});
app.use(VueMagnifier);
app.use(VueRecaptchaPlugin, {
    v2SiteKey: config.CAPCHA_KEY,
});
app.component('VSelect', vSelect);
app.component('CartItemImage', CartItemImage);
app.directive('click-outside', ClickOutside);

app.mount('#app');

initLinkWords();
